import { render } from "./PayButton.vue?vue&type=template&id=d9175a84"
import script from "./PayButton.vue?vue&type=script&lang=js"
export * from "./PayButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__